module.exports = __webpack_public_path__ + "img/maria-fernanda.c022b8a7.png";